import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const ExactLength =
	(length: number): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const value: string = control.value || '';

		const exactLengthRegex = new RegExp(`^.{${length}}$`);

		if (!exactLengthRegex.test(value)) {
			return { exactLengthRegex: true };
		}

		return null;
	};
